import React from 'react';
import { handleCheckoutClick, CHECKOUT_URL } from '../lib/pixel';
export function Nav() {
  return <nav className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-[var(--color-pale-pink)]" data-id="element-121">
      <div className="container mx-auto px-6 lg:px-12 py-4 flex items-center justify-between" data-id="element-122">
        <h1 className="text-xl lg:text-2xl font-bold text-[var(--color-charcoal)]" data-id="element-123">
          Código Hormonal 40+
        </h1>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="bg-[var(--color-charcoal)] text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-[var(--color-dark-sage)] transition-colors shadow-sm" data-id="element-124">
          Quiero mi guía — $8.49
        </a>
      </div>
    </nav>;
}